import { GET_CM_CREDIT_CARD_BANNER_DATA } from '../actionTypes/CMCreditCardBannerDataActionTypes';

const getCMCreditCardBannerData = (payload) => ({
    type: GET_CM_CREDIT_CARD_BANNER_DATA,
    payload,
});

export default getCMCreditCardBannerData;
